<template>
  <el-dialog
    custom-class="theme-dialog split-line-footer-dialog no-padding-top-dialog"
    title="人工录入问卷"
    :visible.sync="visibility"
    width="981px"
    append-to-body
  >
    <EntrustInputSurvey isDialog/>
  </el-dialog>
</template>
<script>
import EntrustInputSurvey from "./EntrustInputSurvey"
export default {
  name: "manualInputDialog",
  components: {EntrustInputSurvey},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibility: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  }
}
</script>
<style lang="">
  
</style>